// Format SDG currency with K/M abbreviations
export const formatSDG = (amount) => {
  if (!amount) return "0 SDG";
  amount = Number(amount);
  if (isNaN(amount)) return "0 SDG";
  if (amount >= 1000000) {
    return `${(amount / 1000000).toFixed(1)}M SDG`;
  }
  if (amount >= 1000) {
    return `${(amount / 1000).toFixed(1)}K SDG`;
  }
  return `${amount.toLocaleString()} SDG`;
};